module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./CompleteView.js"));
	}, "Questionnaire");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=Questionnaire!./src/pages/Shop/Member/Questionnaire/CompleteView.js
// module id = 1934
// module chunks = 367